/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DownloadExportInternalRequest} from '@cash-web/protos/squareup/cash/activityexport/api/v1/service.pb'
import {DownloadExportResponse} from '@cash-web/protos/squareup/cash/activityexport/api/v1/service.pb'


export const downloadExportInternal = (request: DownloadExportInternalRequest, options?: CashRequestOptions) => post<DownloadExportInternalRequest, DownloadExportResponse>("/2.0/cash/download-export-internal", request, {...options, rejectOnError: true })